import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import DismissNotification from 'actions/notification/dismiss_notification';
import OpenConversations from 'actions/reporting/open_conversations';
import RefreshEmbedTokensConversations from 'actions/reporting/refresh_embed_tokens_conversations';
import { EmbeddedReport } from './embedded_report';

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const isCookielessLookerEmbedEnabled = isFeatureEnabled('cookielessLookerEmbed');
  const embedTokensConversationsProvider = getProvider('embedTokensConversations');
  const reportUrl = _.get(embedTokensConversationsProvider.get(), 'url');

  const currentLocation = getProvider('currentLocation').get();

  return {
    currentLocation,
    isCookielessLookerEmbedEnabled,
    isLoading: embedTokensConversationsProvider.isLoading(),
    reportUrl,
    sessionReferenceTokenTtl: _.get(embedTokensConversationsProvider.get(), 'sessionReferenceTokenTtl'),
    embedTokensConversationsProvider,
  };
}

function mapExecuteToProps(executeAction, { onStatusChange }) {
  return {
    dismissEmbedTokenExpiringNotification: () => {
      executeAction(DismissNotification, 'embed-token-expiring-conversations');
    },
    onTimezoneChange: _.noop,
    onStatusChange: newStatus => onStatusChange(newStatus),
    openConversations: timezone => executeAction(OpenConversations, { timezone }),
    onTokenRequest: embedTokensConversationsProvider => {
      const report = embedTokensConversationsProvider.get();
      if (!report) return;

      const tokenExpirationTimeRemaining = moment(report.tokenExpiry).diff(moment.now(), 'seconds');

      if (tokenExpirationTimeRemaining < 100) {
        executeAction(RefreshEmbedTokensConversations, {
          apiToken: report.apiToken,
          navigationToken: report.navigationToken,
        });
        return;
      }

      return {
        api_token: report.apiToken,
        api_token_ttl: report.apiTokenTtl,
        navigation_token: report.navigationToken,
        navigation_token_ttl: report.navigationTokenTtl,
        session_reference_token_ttl: report.sessionReferenceTokenTtl,
      };
    },
    showEmbedTokenExpiringNotification: _.noop,
  };
}

function mergeProps(stateProps, executeProps, ownProps) {
  return {
    ...ownProps,
    ...stateProps,
    ...executeProps,
    openReport: () => executeProps.openConversations(stateProps.currentLocation.timezone || ''),
    onTokenRequest: () => executeProps.onTokenRequest(stateProps.embedTokensConversationsProvider),
  };
}

const ConversationsEmbeddedReport = connect(mapStateToProps, mapExecuteToProps, mergeProps)(EmbeddedReport);

ConversationsEmbeddedReport.defaultProps = {
  onStatusChange: _.noop,
};

ConversationsEmbeddedReport.propTypes = {
  onStatusChange: PropTypes.func,
};

export default ConversationsEmbeddedReport;
